// extracted by mini-css-extract-plugin
export default {"label":"ModeSwitch_label__2Ol5P","input":"ModeSwitch_input__N4F7c","toggle":"ModeSwitch_toggle__CTgM-"};